import services from './../../lib/Services';

const STATUS = {
    ON: 0,
    OFF: 1,
    WARNING: 2
};

class Powerplant
{
    constructor(app_id, parameters)
    {
        this.app_id = app_id;
        this.name = parameters.name;
        this.total_power = Number(parameters.total_power);
        this.latitude = Number(parameters.latitude);
        this.longitude = Number(parameters.longitude);
        this.lastTrackerAvailability = null;
        this.state = [];
        this.step = null;
        this.displayed = true;
    }
    
    isDisplayed(displayed = null)
    {
        if(displayed !== null) {
            this.displayed = displayed;
        }
        return this.displayed;
    }
    
    update(state)
    {
        let updated = false;
        for(let i in state) {
            if(state[i] !== this.state[i]) {
                this.state[i] = state[i];
                updated = true;
            }
        }
        return (updated === true);
    }
    
    setStep(step)
    {
        this.step = 0;
        if(step === 'Waiting for commissioning') this.step = 1;
        if(step === 'Building') this.step = 2;
        if(step === 'Abandoned') this.step = 3;
        return this;
    }
    
    getStep()
    {
        return this.step;
    }
    
    setLastDailyTrackerAvailability(availability)
    {
        this.lastTrackerAvailability = availability;
        return this;
    }

    getLastDailyTrackerAvailability()
    {
        return this.lastTrackerAvailability;
    }
    
    getStatus()
    {
        if(this.state.LostRemoteConnection !== false) return STATUS.OFF;
        if(services.getUser().isSuperAdmin() && this.getWarnings().filter(line => line[0] === STATUS.OFF).length > 0) return STATUS.WARNING;
        return STATUS.ON;
    }
    
    getWarnings()
    {
        const warnings = [];
        if(this.state.StuckWarningCounter > 0) {
            warnings.push([STATUS.WARNING, "stuck " + this.state.StuckWarningCounter]);
        }
        if(this.state.ActiveVPN === false) {
            warnings.push([STATUS.OFF, "vpn"]);
            return warnings;
        }
        if(this.state.RabbitMQConnection === false) {
            warnings.push([STATUS.OFF, "upload"]);
        } else {
            if(this.state.LostRemoteConnection === true) {
                warnings.push([STATUS.OFF, "no data"]);
            }
        }
        if(this.state.MysqlReplication === false) {
            warnings.push([STATUS.WARNING, "synchro"]);
        }
        if(this.state.ServicesStatus === false) {
            warnings.push([STATUS.OFF, "services"]);
        }
        if(this.state.CtrlCpuLoad >= 90 || this.state.SrvCpuLoad >= 90) {
            warnings.push([STATUS.OFF, "cpu"]);
        } else {
            if(this.state.CtrlCpuLoad >= 80 || this.state.SrvCpuLoad >= 80) {
                warnings.push([STATUS.WARNING, "cpu"]);
            }
        }
        if(this.state.CtrlRamUsage >= 90 || this.state.SrvRamUsage >= 90) {
            warnings.push([STATUS.OFF, "mem"]);
        } else {
            if(this.state.CtrlRamUsage >= 80 || this.state.SrvRamUsage >= 80) {
                warnings.push([STATUS.WARNING, "mem"]);
            }
        }
        if(this.state.CtrlDiskUsage >= 90 || this.state.SrvDiskUsage >= 90) {
            warnings.push([STATUS.OFF, "disk"]);
        } else {
            if(this.state.CtrlDiskUsage >= 80 || this.state.SrvDiskUsage >= 80) {
                warnings.push([STATUS.WARNING, "disk"]);
            }
        }
        if(this.state.AlarmWind === true) {
            warnings.push([STATUS.WARNING, "wind"]);
        }
        return warnings;
    }

    getDirectionAsString()
    {
        if(this.state.WindDirection < 22.5 || this.state.WindDirection > 337.5)
            return 'N';
        if(this.state.WindDirection < 67.5 && this.state.WindDirection > 22.5)
            return 'NE';
        if(this.state.WindDirection < 112.5 && this.state.WindDirection > 67.5)
            return 'E';
        if(this.state.WindDirection < 157.5 && this.state.WindDirection > 112.5)
            return 'SE';
        if(this.state.WindDirection < 202.5 && this.state.WindDirection > 157.5)
            return 'S';
        if(this.state.WindDirection < 247.5 && this.state.WindDirection > 202.5)
            return 'SW';
        if(this.state.WindDirection < 292.5 && this.state.WindDirection > 247.5)
            return 'W';
        return 'NW';
    }
    
    getPercentAuto()
    {
        const total = this.getNbTrackersTotal();
        if (total > 0) {
            return Math.floor((this.state.NbTrackersOk / total) * 100);
        }
        return 0;
    }

    getLatitude()
    {
        return this.latitude;
    }
    
    getLongitude()
    {
        return this.longitude;
    }
    
    getNbTrackersTotal()
    {
        return this.getNbTrackersOk() + this.getNbTrackersManual() + this.getNbTrackersError();
    }
    
    getNbTrackersOk()
    {
        return this.state.NbTrackersOk ? this.state.NbTrackersOk : 0;
    }

    getNbTrackersManual()
    {
        return this.state.NbTrackersManual ? this.state.NbTrackersManual : 0;
    }

    getNbTrackersError()
    {
        return this.state.NbTrackersError ? this.state.NbTrackersError : 0;
    }
    
    getTotalPower()
    {
        return this.total_power;
    }
    
    getWindSafety()
    {
        return this.state.OneWindSafety;
    }
    
    getWindSpeed()
    {
        return Math.round(this.state.WindSpeed * 3.6);
    }
    
    getAlarmWind()
    {
        return this.state.AlarmWind;
    }
    
    getPowerSimul()
    {
        return this.state.PowerSimul;
    }
    
    getName()
    {
        return this.name;
    }
    
    getAppId()
    {
        return this.app_id;
    }
}

export default Powerplant;